import * as XLSX from 'xlsx';

export const downloadExcel = (
  title: string,
  headers: string[],
  data: any[][],
  fileName: string,
  totalPaidAmount?: string,
  dueAmount?: string,
  totalAmount?: string,
  summaryNote?: string
) => {
  // Create a new workbook and worksheet
  const workbook = XLSX.utils.book_new();
  
  // Prepare worksheet data starting with Title and Date
  const worksheetData: any[][] = [
    [title],
    [`Generated on: ${new Date().toLocaleString()}`],
    [], // Empty row for spacing
  ];

  // Add Summary Information if present
  if (totalAmount) {
    worksheetData.push([`Total Amount: ${totalAmount}`]);
  }
  if (totalPaidAmount) {
    worksheetData.push([`Total Paid Amount: ${totalPaidAmount}`]);
  }
  if (dueAmount) {
    worksheetData.push([`Due Amount: ${dueAmount}`]);
  }
  if (summaryNote) {
    worksheetData.push([`Note: ${summaryNote}`]);
  }
  
  if (totalAmount || totalPaidAmount || dueAmount || summaryNote) {
    worksheetData.push([]); // Add spacing after summary
  }

  // Add Table Headers and Data
  worksheetData.push(headers);
  data.forEach(row => worksheetData.push(row));

  // Create Worksheet
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  // Set column widths (approximate based on content)
  const maxWidths = headers.map((header, i) => {
    const colData = [header, ...data.map(row => row[i]?.toString() || "")];
    return { wch: Math.max(...colData.map(val => val.length)) + 2 };
  });
  worksheet['!cols'] = maxWidths;

  // Add worksheet to workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');

  // Trigger download
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
